import MarketingMaterialSampleWatermark from './MarketingMaterialSampleWatermark';

export default MarketingMaterialSampleWatermark;
